import { ApiRes, api } from '@src/utils/api/client'

export interface ZohoResponse {
    success: boolean
}
export const zohoPushSingleAsset = (asset_uid: string): ApiRes<ZohoResponse> =>
    api.post(`/manage/zoho-sync/assets/${asset_uid}`)

export const zohoPushMultipleAssets = (
    asset_ids: string[]
): ApiRes<ZohoResponse> => api.post('/manage/zoho-sync/assets', { asset_ids })

export const zohoPushMultipleInvestors = (
    investor_ids: string[]
): ApiRes<ZohoResponse> =>
    api.post('/manage/zoho-sync/investors', { investor_ids })

export const zohoPushSingleInvestor = (
    investor_uid: string
): ApiRes<ZohoResponse> =>
    api.post(`/manage/zoho-sync/investors/${investor_uid}`)

export const zohoPushSingleInvestment = (
    investment_uid: string
): ApiRes<ZohoResponse> =>
    api.post(`/manage/zoho-sync/investments/${investment_uid}`)

export const zohoPushMultipleInvestments = (
    investment_ids: string[]
): ApiRes<ZohoResponse> =>
    api.post('/manage/zoho-sync/investments', { investment_ids })
